import { Component, OnInit, ViewChild } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { UtilsService } from 'src/app/shared/utils.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { VideoDialogComponent } from '../video-dialog/video-dialog.component';
import { FormControl } from '@angular/forms';

@Component({
    selector: 'app-sales-script',
    templateUrl: './sales-script.component.html',
    styleUrls: ['./sales-script.component.scss'],
    animations: [
        trigger('fade', [
            transition('void => *', [
                style({ opacity: 0 }),
                animate(3000, style({ opacity: 1 }))
            ])
        ])
    ],
    standalone: false
})

export class SalesScriptComponent implements OnInit {
  interval;
  twoInterval;
  threeInterval;
  fourInterval;
  slideIndex = 0;
  slideIndexMobile = 0;
  twoSlideIndex = 0;
  threeSlideIndex = 0;
  fourSlideIndex = 0;
  selectedSection = 1;
  mobileSelectedSection = 1;
  selected = new FormControl(0);

  constructor(public utils: UtilsService, private route: ActivatedRoute, public dialog: MatDialog) {
    slideIndex = 0;
    slideIndexMobile = 0;
    this.slideIndex = 0;
    this.twoSlideIndex = 0;
    twoSlideIndex = 0;
    this.threeSlideIndex = 0;
    threeSlideIndex = 0;
    this.fourSlideIndex = 0;
    fourSlideIndex = 0;
  }

  ngOnInit(): void {
    this.utils.setTitle('Welcome');
    if (this.utils.getPopupVideo()) {
      this.openVideo();
      this.utils.setPopupVideo(false);
    }
    // this.interval = setInterval(() => {
    //   this.handler();
    // }, 3000);
    // this.twoInterval = setInterval(() => {
    //   this.twoHandler();
    // }, 3000);
    // this.threeInterval = setInterval(() => {
    //   this.threeHandler();
    // }, 3000);
    // this.fourInterval = setInterval(() => {
    //   this.fourHandler();
    // }, 3000);
  }

  onTabChange(event: any){
    this.selected.setValue(event);
  }

  navigateToSection(selectedIndex: any) {
    this.selectedSection = selectedIndex;
  }

  navigateToSectionMobile( selectedIndex: any) {
    this.mobileSelectedSection = selectedIndex;
  }

  handler() {
    if (slideIndex === 0 || slideIndex === 1 || slideIndex === 2 || slideIndex === 3) {
      slideIndex++;
      this.slideIndex++;
    } else if (slideIndex === 4) {
      slideIndex = 0;
      this.slideIndex = 0;
    } else {
      slideIndex = 0;
      this.slideIndex = 0;
    }
  }

  handlerBack() {
    if (slideIndex === 4 || slideIndex === 1 || slideIndex === 2 || slideIndex === 3) {
      slideIndex--;
      this.slideIndex--;
    } else if (slideIndex === 0) {
      slideIndex = 4;
      this.slideIndex = 4;
    } else {
      slideIndex = 0;
      this.slideIndex = 0;
    }
  }

  mobileHandler() {
    if (slideIndexMobile === 0 || slideIndexMobile === 1 || slideIndexMobile === 2 || slideIndexMobile === 3) {
      slideIndexMobile++;
      this.slideIndexMobile++;
    } else if (slideIndexMobile === 4) {
      slideIndexMobile = 0;
      this.slideIndexMobile = 0;
    } else {
      slideIndexMobile = 0;
      this.slideIndexMobile = 0;
    }
  }

  mobileHandlerBack() {
    if (slideIndexMobile === 4 || slideIndexMobile === 1 || slideIndexMobile === 2 || slideIndexMobile === 3) {
      slideIndexMobile--;
      this.slideIndexMobile--;
    } else if (slideIndex === 0) {
      slideIndexMobile = 4;
      this.slideIndexMobile = 4;
    } else {
      slideIndexMobile = 0;
      this.slideIndexMobile = 0;
    }
  }

  twoHandler() {
    if (twoSlideIndex === 0) {
      twoSlideIndex++;
      this.twoSlideIndex++;
    } else if (twoSlideIndex === 1) {
      twoSlideIndex = 0;
      this.twoSlideIndex = 0;
    } else {
      twoSlideIndex = 0;
      this.twoSlideIndex = 0;
    }
  }

  twoHandlerBack() {
    if (twoSlideIndex === 1) {
      twoSlideIndex--;
      this.twoSlideIndex--;
    } else if (twoSlideIndex === 0) {
      twoSlideIndex = 1;
      this.twoSlideIndex = 1;
    } else {
      twoSlideIndex = 0;
      this.twoSlideIndex = 0;
    }
  }

  threeHandler() {
    if (threeSlideIndex === 0 || threeSlideIndex === 1) {
      threeSlideIndex++;
      this.threeSlideIndex++;
    } else if (threeSlideIndex === 2) {
      threeSlideIndex = 0;
      this.threeSlideIndex = 0;
    } else {
      threeSlideIndex = 0;
      this.threeSlideIndex = 0;
    }
  }

  threeHandlerBack() {
    if (threeSlideIndex === 2 || threeSlideIndex === 1) {
      threeSlideIndex--;
      this.threeSlideIndex--;
    } else if (threeSlideIndex === 0) {
      threeSlideIndex = 2;
      this.threeSlideIndex = 2;
    } else {
      threeSlideIndex = 0;
      this.threeSlideIndex = 0;
    }
  }

  fourHandler() {
    if (fourSlideIndex === 0 || fourSlideIndex === 1 || fourSlideIndex === 2) {
      fourSlideIndex++;
      this.fourSlideIndex++;
    } else if (fourSlideIndex === 3) {
      fourSlideIndex = 0;
      this.fourSlideIndex = 0;
    } else {
      fourSlideIndex = 0;
      this.fourSlideIndex = 0;
    }
  }

  fourHandlerBack() {
    if (fourSlideIndex === 3 || fourSlideIndex === 1 || fourSlideIndex === 2) {
      fourSlideIndex--;
      this.fourSlideIndex--;
    } else if (fourSlideIndex === 0) {
      fourSlideIndex = 3;
      this.fourSlideIndex = 3;
    } else {
      fourSlideIndex = 0;
      this.fourSlideIndex = 0;
    }
  }

  currentSlide(n: any) {
    slideIndex = n;
    this.slideIndex = n;
  }

  currentSlideMobile(n: any) {
    slideIndexMobile = n;
    this.slideIndexMobile = n;
  }

  twoCurrentSlide(n: any) {
    twoSlideIndex = n;
    this.twoSlideIndex = n;
  }

  threeCurrentSlide(n: any) {
    threeSlideIndex = n;
    this.threeSlideIndex = n;
  }

  fourCurrentSlide(n: any) {
    fourSlideIndex = n;
    this.fourSlideIndex = n;
  }

  openVideo() {
    const dialogRef = this.dialog.open(VideoDialogComponent, {disableClose: true,});
      dialogRef.afterClosed().subscribe((status) => {
      });
  }
}
let slideIndex = 0;
let slideIndexMobile = 0;
let twoSlideIndex = 0;
let threeSlideIndex = 0;
let fourSlideIndex = 0;

